import { createAsyncThunk } from '@reduxjs/toolkit';

import { IQuiz } from '.';
import { APIDataProvider, TApiResponse, ApiPaths } from '../../api';

export interface IGetAllQuiz {
  limit: number;
  offset: number;
  subject?: string;
  curriculum?: string;
  grade?: string;
  topicId?: string;
  paper?: string;
  subjectLevel?: string;
  subjectCode?: string;
}

export interface IGetMyQuizHistory {
  userId: string;
  limit: number;
  offset: number;
  includeSubmissionCount?: number;
  curriculum?: string;
  subject?: string;
  topicId?: string;
}

const apiDataProvider = new APIDataProvider();

const getQuizListModule = async (data: IGetAllQuiz) => {
  const response = await apiDataProvider.post<
    TApiResponse<{
      offset: number;
      limit: number;
      totalDocs: number;
      docs: Array<IQuiz>;
    }>
  >(`${ApiPaths.quizzes}`, data);

  return response.data;
};

const getQuizHistoryModule = async (data: IGetMyQuizHistory) => {
  const response = await apiDataProvider.post<
    TApiResponse<{
      offset: number;
      limit: number;
      totalDocs: number;
      docs: Array<IQuiz>;
    }>
  >(`${ApiPaths.quizzes}/history`, data);

  return response.data;
};

export const getQuizById = createAsyncThunk(
  'user/quiz/id',
  async (id: string) => {
    const response = await apiDataProvider.get<TApiResponse<IQuiz>>(
      `${ApiPaths.quizzes}/${id}`
    );
    return response.data;
  }
);

export const getQuizBySubTopicId = createAsyncThunk(
  'user/quiz/getBySubTopicId',
  async (data: {
    subTopicId: string;
    paper: string;
    redirectToquizHistory?: boolean;
  }) => {
    const response = await apiDataProvider.post<TApiResponse<IQuiz>>(
      `${ApiPaths.quizzes}/getBySubTopicId`,
      { subTopicId: data.subTopicId, paper: data.paper }
    );

    return response.data;
  }
);

export const checkAllPapersBySubTopicId = createAsyncThunk(
  'user/quiz/checkPapersBySubTopicId',
  async (subTopicId: string) => {
    const response = await apiDataProvider.get<TApiResponse<any>>(
      `${ApiPaths.quizzes}/checkPapersBySubTopicId/${subTopicId}`
    );
    return response.data;
  }
);

export const getQuizHistory = createAsyncThunk(
  'user/quiz/my-history',
  getQuizHistoryModule
);

export const loadMoreQuizHistory = createAsyncThunk(
  'user/quiz/my-history/loadMore',
  getQuizHistoryModule
);

export const getQuizList = createAsyncThunk(
  'user/quiz/list',
  getQuizListModule
);

export const loadMoreQuizList = createAsyncThunk(
  'user/quiz/loadMore',
  getQuizListModule
);
